"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var validator = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{11,12}$/;
var validateUserAccountID = function validateUserAccountID(uuid) {
  if (typeof uuid !== 'string') return false;
  var value = uuid.replace(/[''"]+/g, '');
  return validator.test(value);
};
var _default = exports["default"] = validateUserAccountID;